import $ from 'jquery'

// "Copy Codes" on the Access tab puts every EDGAR code the section shows on the
// clipboard as label/value lines. The inputs are disabled while the section is idle, which does not
// affect reading .val(), so this works in both the read and edit states.

function codesText($section) {
  return $section
    .find('[data-edgar-code-label]')
    .map(function () {
      return `${$(this).data('edgar-code-label')}: ${$(this).val() || ''}`
    })
    .get()
    .join('\n')
}

// navigator.clipboard needs a secure context, which the dev host over plain http is
// not, so fall back to a throwaway textarea and execCommand there.
function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  }

  return new Promise(function (resolve, reject) {
    const $scratch = $('<textarea>')
      .val(text)
      .css({ position: 'fixed', top: '-1000px', opacity: 0 })
      .appendTo(document.body)

    $scratch.get(0).select()

    let ok = false
    try {
      ok = document.execCommand('copy')
    } catch (e) {
      ok = false
    }

    $scratch.remove()
    ok ? resolve() : reject(new Error('copy command was rejected'))
  })
}

function flash($btn, label) {
  const original = $btn.data('original-label') || $btn.text()

  $btn.data('original-label', original)
  $btn.text(label)

  setTimeout(function () {
    $btn.text($btn.data('original-label'))
  }, 1500)
}

// the per-field icons have no text to relabel, so they swap the icon for a tick or a
// cross instead -- the button keeps its width and the row does not shift
function flashIcon($btn, iconClass) {
  const $icon = $btn.find('i')
  const original = $btn.data('original-icon') || $icon.attr('class')

  $btn.data('original-icon', original)
  $icon.attr('class', iconClass)

  setTimeout(function () {
    $icon.attr('class', $btn.data('original-icon'))
  }, 1500)
}

function initCopyEdgarAccessCodes() {
  $(document).on('click', '[data-action="copy-edgar-access-codes"]', function () {
    const $btn = $(this)
    const $section = $btn.closest('[data-editable-section]')

    copyText(codesText($section))
      .then(function () { flash($btn, 'Copied') })
      .catch(function () { flash($btn, 'Copy failed') })
  })

  // the icon beside each label copies just that field's value, with no label
  $(document).on('click', '[data-action="copy-edgar-access-code"]', function () {
    const $btn = $(this)
    const value = $btn.closest('.issuer-admin-access-code-row').find('[data-edgar-code-label]').val() || ''

    if (value === '') {
      flashIcon($btn, 'fas fa-times')
      return
    }

    copyText(value)
      .then(function () { flashIcon($btn, 'fas fa-check') })
      .catch(function () { flashIcon($btn, 'fas fa-times') })
  })
}

document.addEventListener('DOMContentLoaded', initCopyEdgarAccessCodes)

export default initCopyEdgarAccessCodes
